module.exports = __webpack_public_path__ + "img/TKE.07848387.png";